<template><!-- svgo-optimised -->
<svg class="icon icon__drag-close" viewBox="0 0 40 2" xmlns="http://www.w3.org/2000/svg"><path d="M1 1h38" stroke-linecap="round" stroke-width="2"/></svg></template>